<template>
    <el-form ref="universityInfoForm" :model="universityInfo" :rules="rules">
        <el-col class="university-name-col">
            <el-form-item prop="name">
                <el-input v-model="universityInfo.name" placeholder="请输入学校全称" maxlength="250"></el-input>
            </el-form-item>
        </el-col>
        <el-col class="university-abbr-col">
            <el-form-item prop="abbreviation">
                <el-input v-model="universityInfo.abbreviation" placeholder="请输入简称" maxlength="20"></el-input>
            </el-form-item>
        </el-col>
        <el-col class="checkbox-col">
            <el-checkbox v-model="universityInfo.hasSaturdayCourse">星期六有课？</el-checkbox>
        </el-col>
        <el-col class="checkbox-col">
            <el-checkbox v-model="universityInfo.hasSundayCourse">星期天有课？</el-checkbox>
        </el-col>
        <el-col class="timepicker-col-close">
            <el-button type="text" @click="deleteRow"><i class="el-icon el-icon-close delete-row-icon"></i></el-button>
        </el-col>
        <el-col class="timepicker-col-close">
            <el-button v-if="isLastRow" type="text" @click="addRow"><i class="el-icon el-icon-plus"></i></el-button>
        </el-col>
    </el-form>
</template>
<style>
    .checkbox-col {
        width: 100px;
        margin-left: 10px;
    }
    .university-name-col {
        width: 240px;
        margin-left: 10px;
    }
    .university-abbr-col {
        width: 110px;
        margin-left: 10px;
    }
</style>

<script>
    export default {
        props: ["rowIndex", "universityInfo", "isLastRow", "universityList"],
        data() {
            let _self = this;
            let nameValidator = (rule, value, callback) => {
                if (value === "") {
                    return callback(new Error("请输入学校全称"));
                } else {
                    _self.universityList.forEach((item, i) => {
                        if (item.id !== _self.universityInfo.id && item.name.toLowerCase() === value.toLowerCase()) {
                            return callback(new Error("学校全称重复"));
                        }
                    });
                    return callback();
                }
            };
            let abbrValidator = (rule, value, callback) => {
                if (value === "") {
                    return callback(new Error("请输入学校简称"));
                } else {
                    _self.universityList.forEach((item, i) => {
                        if (item.id !== _self.universityInfo.id && item.abbreviation.toLowerCase() === value.toLowerCase()) {
                            return callback(new Error("学校简称重复"));
                        }
                    });
                    return callback();
                }
            };
            return {
                rules: {
                    name: [{
                        validator: nameValidator,
                        trigger: "blur"
                    }],
                    abbreviation: [{
                        validator: abbrValidator,
                        trigger: "blur"
                    }]
                }
            }
        },
        created() {},
        methods: {
            validateRow() {
                let validResult = false;
                this.$refs.universityInfoForm.validate(valid => {
                    validResult = valid;
                });
                return validResult;
            },
            deleteRow() {
                this.$emit("deleteRow", this.universityInfo.id);
            },
            addRow() {
                if (!this.validateRow())
                    return;
                this.$emit("addRow");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/universityInfoEditor.vue